import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import Placeholder from 'Pods/ThreeDStudio/Shared/Placeholder/Placeholder'

import arrow from 'images/three_d_studio/remesh/arrow.webp'

function ComingSoon() {
  const t = useTranslation()

  return (
    <Placeholder
      title={t('viewerSidebar.enhance.render.title')}
      description={t('viewerSidebar.enhance.render.description')}
    >
      <div className="render-tab__preview" aria-hidden="true">
        <img
          alt=""
          className="render-tab__preview-image render-tab__preview-image--original"
          src="/assets/three_d_studio/render_tab/dragon_original.webp"
          height={134}
          width={104}
        />
        <span className="render-tab__preview-arrow">
          <img
            src={arrow}
            alt="Arrow"
            width={27}
            height={12}
          />
        </span>
        <img
          alt=""
          className="render-tab__preview-image render-tab__preview-image--rendered"
          src="/assets/three_d_studio/render_tab/dragon_rendered.webp"
          height={144}
          width={144}
        />
      </div>
    </Placeholder>
  )
}

export default memo(ComingSoon)
